import React from 'react';

/** A small "are you sure?" dialog: icon, title, a line of explanation, and the
 *  two choices. Shared so every confirmation on the storefront looks the same —
 *  removing a household member, moving a meal onto someone it conflicts with.
 *  Pass `className="sf-modal--over-meal-modal"` when it opens on top of the meal
 *  modal, which sits at z-index 1000. */
export default function ConfirmModal({
  open = true,
  title,
  icon = '×',
  // 'danger' (red) for destructive confirmations, 'warn' (amber) for a risk the
  // customer is choosing to accept.
  tone = 'danger',
  ariaLabel,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  className = '',
  onConfirm,
  onCancel,
  children,
}) {
  if (!open) return null;

  return (
    <div
      className={`sf-modal${className ? ` ${className}` : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel || title}
    >
      <button type="button" className="sf-modal__backdrop" onClick={onCancel} aria-label="Cancel" />
      <div className={`sf-modal__panel sf-confirm-modal sf-confirm-modal--${tone}`}>
        <div className="sf-confirm-modal__icon" aria-hidden="true">{icon}</div>
        <h2 className="sf-modal__title">{title}</h2>
        <p className="sf-confirm-modal__body">{children}</p>
        <div className="sf-modal__actions">
          <button
            type="button"
            className="sf-btn-flow sf-btn-flow--secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="sf-btn-flow sf-btn-flow--danger"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
